const getDefault = () => {
  return {
    list: []
  }
}

export default {
  namespaced: true,
  state: Object.assign({}, getDefault()),
  mutations: {
    ADD_RECIPIENT(state, data) {
      if (!data) {
        return
      }
      state.list = [...state.list, data]
    },
    DELETE_RECIPIENT(state, index) {
      if (index === undefined) {
        return
      }
      state.list.splice(index, 1)
    },
    EDIT_RECIPIENT(state, data) {
      const { recipient, index } = data

      const list = state.list
      list[index] = { ...recipient, isEditing: false }

      state.list = [...list]
    },
    TOGGLE_EDITING_RECIPIENT(state, data) {
      state.list[data.index].isEditing = data.value
    },
    // eslint-disable-next-line no-unused-vars
    RESET_STATE_ALL(state) {
      state = Object.assign(state, getDefault())
    }
  }
}
